import React from 'react';
import useTranslation from '../hooks/useTranslation';
import './Footer.css';

const Footer = () => {
  const { isRTL } = useTranslation();
  const year = new Date().getFullYear();

  const socialLinks = [
    { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61589288724270', bg: '#1877F2', color: '#fff', icon: 'M22 12.001C22 6.478 17.522 2 12 2C6.477 2 2 6.478 2 12.001C2 16.995 5.657 21.12 10.438 21.879V14.89H7.898V12.001H10.438V9.8C10.438 7.305 11.914 5.955 14.17 5.955C15.253 5.955 16.383 6.147 16.383 6.147V8.586H15.122C13.882 8.586 13.5 9.356 13.5 10.147V12.001H16.223L15.789 14.89H13.5V21.879C18.281 21.12 22 16.995 22 12.001Z' },
    { name: 'Instagram', url: 'https://www.instagram.com/orkinamedia.llc/', bg: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', color: '#fff', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
    { name: 'TikTok', url: 'https://www.tiktok.com/@orkinamedia', bg: '#000000', color: '#fff', icon: 'M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.79a8.18 8.18 0 004.79 1.52V6.85a4.85 4.85 0 01-1.02-.16z' },
    { name: 'X', url: 'https://x.com/orkinamedia', bg: '#000000', color: '#fff', icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
    { name: 'Snapchat', url: 'https://www.snapchat.com/@orkinamedia', bg: '#FFFC00', color: '#000', icon: 'M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z' },
  ];

  return (
    <footer className="footer" role="contentinfo">
      <div className="container footer__grid">
        {/* Brand & Social */}
        <div className="footer__brand">
          <a
            href="#home"
            className="footer__logo"
            aria-label="Orkina Media Production"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <img
              src="/orkina-logo-white.png"
              alt="Orkina Media Production Logo"
              width="180"
              height="60"
              loading="lazy"
              className="footer__logo-img"
            />
          </a>
          <p className="footer__desc">
            {isRTL
              ? 'نحول رؤيتكم إلى واقع إبداعي ملموس من خلال أحدث تقنيات الإنتاج الإعلامي.'
              : 'Transforming your vision into creative reality through state-of-the-art media production.'}
          </p>
          <div className="footer__socials">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={link.name}
                style={{ '--hover-bg': link.bg, '--hover-color': link.color }}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d={link.icon} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer__contact">
          <h4 className="footer__title">{isRTL ? 'اتصل بنا' : 'Contact Us'}</h4>
          <ul className="footer__contact-list">
            <li>
              <a href="/">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>{isRTL ? 'الإمارات العربية المتحدة – الشارقة – المدينة الإعلامية (شمس)' : 'UAE - Sharjah - Media City (Shams)'}</span>
              </a>
            </li>
            <li>
              <a href="tel:0567114651">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
                <span>0567114651</span>
              </a>
            </li>
            <li>
              <a 
                href="#email"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${['support', 'orkina.online'].join('@')}`;
                }}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>{['support', 'orkina.online'].join('@')}</span>
              </a>
            </li>

          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer__links">
          <h4 className="footer__title">{isRTL ? 'روابط سريعة' : 'Quick Links'}</h4>
          <ul>
            <li><a href="#services">{isRTL ? 'خدماتنا' : 'Services'}</a></li>
            <li><a href="#about">{isRTL ? 'من نحن' : 'About Us'}</a></li>
            <li><a href="#contact">{isRTL ? 'اتصل بنا' : 'Contact'}</a></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p className="footer__copy">
            &copy; {year} Orkina Media Production. All rights reserved.
          </p>
          <p className="footer__copy" style={{ marginTop: '6px', fontSize: '0.75rem', opacity: 0.5 }}>
            Created by <a href="https://devitalweb.com" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Devital Web</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
